<template>
  <el-dialog
    style="z-index: 9!important;"
    top="5vh"
    z-index="90"
    :modal-append-to-body="false"
    :append-to-body="true"
    :title="`${this.form.id ? '修改' : '新建'}消息`"
    :visible="visible"
    :show-close="false"
  >
    <el-form ref="form" :model="form" label-width="120px" :rules="rules">
      <el-form-item label="发送方式" prop="send_type">
        <el-select class="w-96" v-model="form.send_type" placeholder="请选择">
          <el-option label="按所有" :value="1"></el-option>
          <el-option label="按基地" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <template v-if="form.send_type == 2">
        <el-form-item label="所属基地" required>
          {{ baseInfo.com_name }}
        </el-form-item>
        <el-form-item label="发送角色" prop="send_role">
          <el-select
            class="w-96"
            multiple
            v-model="form.send_role"
            placeholder="请选择角色（多选）"
          >
            <el-option
              v-for="item in baseRole"
              :key="item.value"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
      </template>
      <el-form-item label="消息标题" prop="title">
        <el-input
          v-model="form.title"
          class="w-96"
          placeholder="请输入消息标题"
        ></el-input>
      </el-form-item>
      <el-form-item label="内容详情" prop="content">
        <div class="form-right-max">
          <script
            id="notice_editor"
            type="text/plain"
            style="width: 100%;line-height: normal;min-height: 300px;"
          ></script>
        </div>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="onCancel">取 消</el-button>
      <el-button size="small" type="primary" @click="onSave">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      visible: false,
      notice_editor: null,
      form: {},
      rules: {
        send_type: [
          { required: true, message: "请输入发送方式", trigger: "change" }
        ],
        send_role: [
          { required: true, message: "请选择发送角色", trigger: "change" }
        ],
        title: [{ required: true, message: "请输入消息标题", trigger: "blur" }],
        content: [{ required: true, message: "请输入正文", trigger: "change" }]
      }
    };
  },
  computed: {
    ...mapGetters(["baseInfo", "baseRole"])
  },
  methods: {
    onOpen(row) {
      console.log(row);
      this.form = row || {
        send_type: "",
        send_role: [],
        title: "",
        content: ""
      };
      this.visible = true;
      this.$nextTick(() => {
        const editor = this.init_ued();
        if (editor) {
          editor.ready(() => {
            editor.setContent(this.form.content || "");
          });
        }
      });
    },
    onCancel() {
      this.form = {};
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
        this.visible = false;
      });
    },
    // 富文本编辑器初始化
    init_ued() {
      let toolbars = [
        "paragraph",
        "fontsize",
        "bold",
        "italic",
        "underline",
        "strikethrough",
        "unlink",
        "|",
        "forecolor",
        "backcolor",
        "background",
        "|",
        "indent",
        "justifyleft",
        "justifycenter",
        "justifyright",
        "justifyjustify",
        "|",
        "insertorderedlist",
        "insertunorderedlist",
        "|",
        "insertimage",
        "inserttable",
        "preview",
        "insertvideo",
        "source"
      ];
      this.notice_editor = window["UE"].getEditor("notice_editor", {
        toolbars: [toolbars],
        autoFloatEnabled: false // 是否保持toolbar位置不动
      });
      return this.notice_editor;
    },
    onSave() {
      const content = this.notice_editor.getContent();
      this.$set(this.form, "content", content.trim());
      const url = !this.form.id
        ? "/api/queue/admin/create_notice"
        : "/api/queue/admin/update_notice";
      const confirmTitle = !this.form.id ? "发送确认" : "修改公告";
      const confirmContent = !this.form.id
        ? "确认发送消息通知吗？将推送到给用户！"
        : "确认修改公告吗？";
      this.$refs.form.validate(async valid => {
        if (!valid) {
          return;
        }
        this.$confirm(confirmContent, confirmTitle, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$common
            .http({
              url,
              data: this.form
            })
            .then(() => {
              this.$message.success("操作成功");
              this.$emit("ok");
              this.onCancel();
            });
        });
      });
    }
  },
  beforeDestroy() {
    window["UE"].delEditor("notice_editor");
  }
};
</script>

<style lang="less" scoped>
/deep/ .el-dialog__body {
  padding: 10px 15px 0px !important;
}
</style>
